import { render, staticRenderFns } from "./ConvenioModal.vue?vue&type=template&id=74893202"
import script from "./ConvenioModal.vue?vue&type=script&lang=js"
export * from "./ConvenioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports